import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card } from 'react-bootstrap';
import { TrendingDown, Package, Calendar, Users } from 'react-feather';

const ExpenseStatistics = ({ statistics }) => {
    if (!statistics) {
        return (
            <div className="text-center py-4">
                <div className="text-muted">Statistika ma'lumotlari yuklanmoqda...</div>
            </div>
        );
    }

    const formatNumber = (number) => {
        return new Intl.NumberFormat('uz-UZ').format(number || 0);
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('uz-UZ').format(amount || 0) + ' so\'m';
    };

    return (
        <div>
            <h5 className="mb-4">
                <TrendingDown size={20} className="me-2" />
                Sarflar Statistikasi
            </h5>

            {/* Summary Cards */}
            <Row className="mb-4">
                <Col md={3}>
                    <Card className="border-0 bg-danger bg-opacity-10">
                        <Card.Body className="text-center">
                            <TrendingDown size={32} className="text-danger mb-2" />
                            <h4 className="text-danger mb-1">{formatNumber(statistics.total_expenses)}</h4>
                            <small className="text-muted">Jami sarflar</small>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="border-0 bg-warning bg-opacity-10">
                        <Card.Body className="text-center">
                            <Package size={32} className="text-warning mb-2" />
                            <h4 className="text-warning mb-1">{formatNumber(statistics.unique_spare_parts)}</h4>
                            <small className="text-muted">Turli ehtiyot qismlar</small>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="border-0 bg-info bg-opacity-10">
                        <Card.Body className="text-center">
                            <Calendar size={32} className="text-info mb-2" />
                            <h4 className="text-info mb-1">{formatNumber(statistics.this_month_expenses)}</h4>
                            <small className="text-muted">Bu oy sarflari</small>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="border-0 bg-success bg-opacity-10">
                        <Card.Body className="text-center">
                            <Users size={32} className="text-success mb-2" />
                            <h4 className="text-success mb-1">{formatNumber(statistics.unique_users)}</h4>
                            <small className="text-muted">Sarflagan xodimlar</small>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Top Spare Parts by Expense */}
            <Row>
                <Col md={6}>
                    <Card>
                        <Card.Header>
                            <h6 className="mb-0">Eng ko'p sarflangan ehtiyot qismlar</h6>
                        </Card.Header>
                        <Card.Body>
                            {statistics.top_spare_parts && statistics.top_spare_parts.length > 0 ? (
                                <div className="list-group list-group-flush">
                                    {statistics.top_spare_parts.map((item, index) => (
                                        <div key={index} className="list-group-item border-0 px-0">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="fw-semibold">{item.name}</div>
                                                    <small className="text-muted">{item.unit}</small>
                                                </div>
                                                <div className="text-end">
                                                    <div className="text-danger fw-bold">
                                                        -{formatNumber(item.total_consumed)}
                                                    </div>
                                                    <small className="text-muted">
                                                        {item.expense_count} marta
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-muted text-center py-3">
                                    Ma'lumot topilmadi
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={6}>
                    <Card>
                        <Card.Header>
                            <h6 className="mb-0">Eng faol sarflovchi xodimlar</h6>
                        </Card.Header>
                        <Card.Body>
                            {statistics.top_users && statistics.top_users.length > 0 ? (
                                <div className="list-group list-group-flush">
                                    {statistics.top_users.map((item, index) => (
                                        <div key={index} className="list-group-item border-0 px-0">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <div>
                                                    <div className="fw-semibold">{item.name}</div>
                                                    <small className="text-muted">Xodim</small>
                                                </div>
                                                <div className="text-end">
                                                    <div className="fw-bold text-primary">
                                                        {formatNumber(item.expense_count)}
                                                    </div>
                                                    <small className="text-muted">sarflar</small>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="text-muted text-center py-3">
                                    Ma'lumot topilmadi
                                </div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Monthly Trend */}
            {statistics.monthly_trend && statistics.monthly_trend.length > 0 && (
                <Row className="mt-4">
                    <Col md={12}>
                        <Card>
                            <Card.Header>
                                <h6 className="mb-0">Oylik sarflar tendensiyasi</h6>
                            </Card.Header>
                            <Card.Body>
                                <div className="table-responsive">
                                    <table className="table table-sm">
                                        <thead>
                                            <tr>
                                                <th>Oy</th>
                                                <th className="text-end">Sarflar soni</th>
                                                <th className="text-end">Jami miqdor</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {statistics.monthly_trend.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.month}</td>
                                                    <td className="text-end">{formatNumber(item.expense_count)}</td>
                                                    <td className="text-end text-danger">
                                                        -{formatNumber(item.total_quantity)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}


        </div>
    );
};

ExpenseStatistics.propTypes = {
    statistics: PropTypes.shape({
        total_expenses: PropTypes.number,
        unique_spare_parts: PropTypes.number,
        this_month_expenses: PropTypes.number,
        unique_users: PropTypes.number,
        top_spare_parts: PropTypes.array,
        top_users: PropTypes.array,
        monthly_trend: PropTypes.array,
        purpose_analysis: PropTypes.array,
    }),
};

export default ExpenseStatistics; 